export default __webpack_public_path__ + "static/media/omnivore-logo.960c8e77.png";